import { Component, computed, input, ViewEncapsulation } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { QuillEditorComponent } from 'ngx-quill';

@Component({
  selector: 'ui-wysiwyg',
  templateUrl: './wysiwyg.component.html',
  styleUrl: './wysiwyg.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [QuillEditorComponent, ReactiveFormsModule],
})
export class UIWysiwyg {
  control = computed(() => {
    const content = this.content();
    return content instanceof FormControl ? content : new FormControl(content ?? '');
  });

  label = input<string>();
  content = input<string | FormControl>();
  readOnly = input<boolean>(false);

  modules = computed(() => {
    return this.readOnly() ? { toolbar: false } : {};
  });
}
